import React from 'react'
import TabbledContent from '../tabbled-content'

export default function TabbledContentDisplay(props) {
  const page = props?.node

  return <TabbledContent page={page} />
}
